import React from "react";

interface FilterButtonProps {
  onClick: () => void;
  label: React.ReactNode;
  isActive?: boolean;
  borderColor?: string;
  textColor?: string;
  width?: string;
}

export const FilterButton: React.FC<FilterButtonProps> = ({
  onClick,
  label,
  isActive = false,
  borderColor = "#fff",
  textColor = "#fff",
  width,
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`${
        width || "w-[160px]"
      } sm:px-4 sm:py-2 3xl:px-5 3xl:py-3 text-sm border rounded-lg hover:bg-gray-50 flex items-center justify-between !bg-transparent whitespace-nowrap`}
      style={{
        borderColor,
        color: textColor,
      }}
    >
      <div className="flex-1 text-left">{label}</div>
      <svg
        className={`w-3.5 h-3.5 transform transition-transform ${
          isActive ? "rotate-180" : ""
        }`}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M19 9l-7 7-7-7"
        />
      </svg>
    </button>
  );
};

export default FilterButton;
